<div class="main-container">
  <br/>
  <h3>Minhas Reservas</h3>
  <hr/>
  <br/>
  @if (!reservations) {
    <div>
      Não há reservas a serem exibidas
      <br/>
      <br/>
      <div>
        <button class="btn btn-md btn-secondary" (click)="goBack()">Voltar</button>
      </div>
      <br/>
    </div>
  }
  @if (reservations) {
    <div>
      <table class="table table-hover reservation">
        <tbody>
          @for (res of reservations; track res) {
            <tr>
              <td>
                <span class="company-name">{{res.companyName}}:</span> &nbsp; <span class="dow">{{res.dayOfWeek}}</span>
                <div>
                  {{res.schedule.substr(0, 10)}} às <span class="dow">{{res.schedule.substr(11,5)}}</span>
                </div>
                <div>
                  <span class="people-qty">{{res.people_qty}} pessoa{{res.people_qty > 1 ? 's':''}}, {{res.building_region_name}}</span>
                </div>
                <div>
                  <span class="status">Situação: <b [class.confirmed]="res.status == 'accepted' || res.status == 'confirmed'">{{res.statusPtbr}}</b></span>
                </div>
                @if (res.expand) {
                  <div>
                    <hr/>
                    <div>
                      <i>{{res.customer_description}}</i>
                      <hr/>
                    </div>
                    <div class="actions-container">
                      <button class="btn btn-md btn-success" (click)="sendWhatsapp(res)">
                        <fa-icon [icon]="faWhatsapp" size="md"></fa-icon>
                      </button> &nbsp; &nbsp;
                      @if (res.status == 'accepted') {
                        <button class="btn btn-md btn-danger" (click)="cancel(res)">
                          <fa-icon [icon]="faXmark" size="md"></fa-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </td>
              <td>
                <button class="btn btn-md btn-secondary" (click)="toggleReservation(res)">
                  @if (!res.expand) {
                    <fa-icon [icon]="faChevronDown" size="md"></fa-icon>
                  }
                  @if (res.expand) {
                    <fa-icon [icon]="faChevronUp" size="md"></fa-icon>
                  }
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
